import createBaseService from "@/api/base-service.ts";
import type { HelpTopic } from "../../types/help-topic";

const helpCenterService = {
	...createBaseService<HelpTopic>("/help-center"),
};

export default helpCenterService;
